import { ExperienceUserExtended } from '../models/experience-user.extended.model';

export class AddExperienceUsers {
    static readonly type = '[ExperienceUser] AddExperienceUsers';

    constructor(public payload: ExperienceUserExtended[]) {}
}
